import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: '../../pages/confirmation-dialog/confirmation-dialog.html',
})
export class ConfirmationDialog 
{
    message: string = "¿Esta seguro de anular la solicitud?"
    confirmButtonText = "Si"
    cancelButtonText = "No"
    
    constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialog>) 
    {
        if(data)
        {
            this.message = data.message || this.message;
            
            if (data.buttonText) 
            {
                this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
                this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
            }
        }
    }

    onConfirmClick(): void { this.dialogRef.close(true); }

    onRejectClick(): void { this.dialogRef.close(false); }
}